import { render } from "./ColorsContent.vue?vue&type=template&id=a15ecc42"
import script from "./ColorsContent.vue?vue&type=script&lang=js"
export * from "./ColorsContent.vue?vue&type=script&lang=js"

import "./ColorsContent.vue?vue&type=style&index=0&id=a15ecc42&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__